var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path, _ellipse7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSpinnerLoader = function SvgSpinnerLoader(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "spinner",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.7622,
    cy: 3.38377,
    rx: 1.93236,
    ry: 1.84186,
    transform: "rotate(11 10.7622 3.38377)",
    fill: "#2277DB"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.31973,
    cy: 15.9485,
    rx: 1.15929,
    ry: 1.105,
    transform: "rotate(11 8.31973 15.9485)",
    fill: "#2277DB"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.74351,
    cy: 4.31858,
    rx: 1.73925,
    ry: 1.6578,
    transform: "rotate(11 5.74351 4.31858)",
    fill: "#2277DB"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.3381,
    cy: 15.0141,
    rx: 0.966178,
    ry: 0.920931,
    transform: "rotate(11 13.3381 15.0141)",
    fill: "#2277DB"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.94941,
    cy: 8.3855,
    rx: 1.54551,
    ry: 1.47313,
    transform: "rotate(11 2.94941 8.3855)",
    fill: "#2277DB"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.1319,
    cy: 10.9483,
    rx: 0.772443,
    ry: 0.736268,
    transform: "rotate(11 16.1319 10.9483)",
    fill: "#2277DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25166 12.1265C2.6367 12.5202 2.48116 13.3203 2.90387 13.9157C3.32596 14.511 4.16668 14.6744 4.78103 14.2806C5.39599 13.8869 5.55153 13.0867 5.12882 12.4914C4.70684 11.8955 3.86765 11.7275 3.25166 12.1265Z",
    fill: "#2277DB"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.0649,
    cy: 6.12916,
    rx: 0.579332,
    ry: 0.552201,
    transform: "rotate(11 15.0649 6.12916)",
    fill: "#2277DB"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSpinnerLoader);
export { ForwardRef as ReactComponent };
export default "images/spinnerLoader.e62897a624e1bedbc166c0c0150491a0.svg";